import type { ReactNode } from "react";

// Has to fit the page margin the PDF is printed with - Chrome draws the header/footer into it without clipping.
export const PDF_PRINT_FRAGMENT_HEIGHT = 60;

type Props = {
  children: ReactNode;
};

/**
 * Root of a page the PDF builder snapshots into Chrome's print header/footer. That context keeps only the markup and
 * wraps it in its own layout, so the fragment must not depend on the app stylesheet or on body/html. Its content is
 * therefore plain HTML with inline styles on purpose - no MUI components, whose styles live in the app's CSS-in-JS
 * stylesheet and would be lost.
 */
export const PdfPrintFragment = ({ children }: Props) => (
  <div
    className="print-root"
    style={{ display: "block", width: "100%", height: PDF_PRINT_FRAGMENT_HEIGHT, boxSizing: "border-box", overflow: "hidden" }}
  >
    {children}
  </div>
);
